import type { FC, PropsWithChildren } from 'react';
import { useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { Image, StyleSheet, useWindowDimensions, View } from 'react-native';

import { PeopleBackground } from '@/assets';

// Note: update resolution in case image is changed
const IMAGE_RESOLUTION = {
  width: 1286,
  height: 1619
};
const aspectRatio = IMAGE_RESOLUTION.width / IMAGE_RESOLUTION.height;

const styles = StyleSheet.create({
  wrapper: { justifyContent: 'center', alignItems: 'center' },
  image: { position: 'absolute', bottom: 0, width: '100%', aspectRatio },
  children: { paddingBottom: '15%', paddingTop: '5%' }
});

export const BackgroundView: FC<PropsWithChildren> = ({ children }) => {
  const { height } = useWindowDimensions();

  // Measure the actual container width (already max-width constrained and
  // centered by the root container) instead of clamping the browser window.
  const [viewWidth, setViewWidth] = useState(0);
  const onLayout = (e: LayoutChangeEvent) =>
    setViewWidth(e.nativeEvent.layout.width);

  const naturalHeight = viewWidth / aspectRatio;
  const viewHeight = naturalHeight ? Math.min(naturalHeight, height * 0.6) : 0;

  return (
    <View
      style={[styles.wrapper, viewHeight > 0 && { height: viewHeight }]}
      onLayout={onLayout}
    >
      <Image
        source={PeopleBackground}
        resizeMethod="scale"
        resizeMode="cover"
        style={[styles.image, { height: naturalHeight }]}
        accessibilityIgnoresInvertColors
      />

      <View style={styles.children}>{children}</View>
    </View>
  );
};
